import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../core';
import { Integracao } from '../integracao';
import { IntegracaoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class IntegracaoErpHttpService  {
    resource = 'integracao';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as integrações do tipo ERP */
    search(): Observable<Integracao[]> {
        const filter = new IntegracaoFilter()
                            .withPlataformaTipoERP();
        return this.customHttp.get<Integracao[]>(this.pathApi, {params: filter.createParams(null)});
    }

    /** Pesquisa todas as integrações do tipo ERP ativas */
    searchAtivas(): Observable<Integracao[]> {
        const filter = new IntegracaoFilter()
                            .withPlataformaTipoERP()
                            .withSituacaoAtiva();
        return this.customHttp.get<Integracao[]>(this.pathApi, {params: filter.createParams(null)});
    }
}
